module.exports = __webpack_public_path__ + "static/media/e-mail-success.a7a1ce3d.svg";